/**
 * Latest A/L batch year shown on the public site.
 * During calendar year N, only batches with al_year ≤ N - 1 are visible.
 */
export function maxPublicBatchAlYear(date = new Date()): number {
  return date.getFullYear() - 1;
}
